module.exports = __webpack_public_path__ + "img/23_fineStaff_nzq.fea53fa4.png";